import { render, staticRenderFns } from "./INFO.vue?vue&type=template&id=7e5e6dac&"
import script from "./INFO.vue?vue&type=script&lang=js&"
export * from "./INFO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports